<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cd"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Código</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="descr"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Descrição</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status"
              :options="optionsLivStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="municipio"
              :options="optionsMunicipio"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Município"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="3" class="m-t-5px p-a-0">
            <multiselect
              v-model="municipio_cep"
              :options="optionsMunicipio"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Município por faixa de Cep"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      helpForm: new Form({ params: [] }),
      cd: "",
      descr: "",
      municipio: "",
      municipio_cep: "",
      optionsLivStatus: [],
      optionsMunicipio: [],
      status: [],
      data_filter: [],
    };
  },
  mounted() {
    this.getStatus();
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        cd: this.cd,        
        municipio: this.municipio,
        municipio_cep: this.municipio_cep,
        descr: this.descr,
        status: this.status,
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.cd = ""; // clear the text in text input
      this.descr = "";
      this.municipio = "";
      this.municipio_cep = "";
      this.status = "";
      this.$events.fire("filter-reset");
    },
    getStatus() {
      this.helpForm.params = { tabela: "regiao", coluna: "status" };

      this.helpForm
        .get("/api/listitemvalor/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.items.forEach((obj) => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, false, false);
        });

      this.helpForm
        .get("/api/regiaomunicipio/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.municipio.forEach((obj)=>{
            this.optionsMunicipio.push({
              label: obj.nome + " - "+ obj.uf.cd,
              value: obj.municipio_id
              })
          })
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, false, false);
        });
    },

  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
